__turbopack_context__.v({
  "className": "open_sans_1b01f905-module__IUynnG__className",
  "variable": "open_sans_1b01f905-module__IUynnG__variable",
});
